import React from 'react';
import styled from 'styled-components';
import PageContainer from '../../components/containers/PageContainer';
import { theme } from '../../assets/styles/theme';
import ItemsTable from './components/ItemsTable';

const Container = styled.div`
  padding: 0 ${theme.paddingStandard}px;
  flex-direction: column;
  display: flex;
  width: 100%;
`;

const Items = () => {
  return (
    <PageContainer>
      <Container>
        <ItemsTable />
      </Container>
    </PageContainer>
  );
};

export default Items;
